import { getChildByType } from "react-nanny";
import { Slot } from "../../../components/layouts/slot";
import { RowBorder } from "../../../components/molecules/table";
import { RichTextEditorBase } from "../../../components/rich-text-editor/rich-text-editor-base";

const Content = Slot();

const Container = (props: {
  children: React.ReactNode;
  title: string;
  description?: string;
  isRequired?: boolean;
}) => {
  const content = props.children ? (
    getChildByType(props.children, Content)
  ) : (
    <></>
  );
  return (
    <div className="rounded-md bg-white px-10 py-8 shadow-md">
      <h2 className="font-inter flex gap-x-1 text-xl font-medium">
        {props.title}
        {props.isRequired ? (
          <span className="text-ui-red">
            *<span className="sr-only">Required</span>
          </span>
        ) : null}
      </h2>

      {props.description ? (
        <RowBorder className="pb-4 pt-3">
          <RichTextEditorBase
            editorClassName="no-padding"
            content={props.description}
            readOnly={true}
          />
        </RowBorder>
      ) : null}
      {content}
    </div>
  );
};

export const SelfApplySectionContainer = {
  Content,
  Container,
};
